import{selectorMatches as t}from"./selectorMatches.min.mjs";import{doesSomeParentMatch as e}from"./doesSomeParentMatch.min.mjs";function o(o,m){let n=!0;const r=t(o,m.pop());return r&&m.length&&(n=e(o,m)),r&&n&&0===m.length}export{o as elementMatchesRule};
//# sourceMappingURL=elementMatchesRule.min.mjs.map
